import { render, staticRenderFns } from "./guiderRewardDetails.vue?vue&type=template&id=055bcd15&scoped=true&"
import script from "./guiderRewardDetails.vue?vue&type=script&lang=js&"
export * from "./guiderRewardDetails.vue?vue&type=script&lang=js&"
import style0 from "./guiderRewardDetails.vue?vue&type=style&index=0&id=055bcd15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055bcd15",
  null
  
)

component.options.__file = "guiderRewardDetails.vue"
export default component.exports